import React from 'react';

import styles from './contestJudgesStyles';

import ContestJudge from './contestJudge/contestJudge';
import HammerIcon from 'buyside/svgs/hammer.svg';

const ContestJudges = ({ judges }) => {
  return (
    <div>
      <h3 className={styles.judgeDescriptionHeader}>
        <HammerIcon className={styles.judgeIcon} /> Judges
      </h3>
      <div>
        {judges.map(judge => (
          <ContestJudge judge={judge} key={judge.id} />
        ))}
      </div>
    </div>
  );
};

export default ContestJudges;
